import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue } from 'firebase/database';

const AccountantSocDrawLotteryList = () => {
  const [loading, setLoading] = useState(true);
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [allLotteries, setAllLotteries] = useState([]);

  useEffect(() => {
    setLoading(true);
    const socRef = ref(db, 'ekamwatapzp/SocietyRegistrations');
    
    onValue(socRef, (snapshot) => {
        if (snapshot.exists()) {
            const data = snapshot.val();
            let lotteriesArray = [];
            let datesSet = new Set();

            Object.keys(data).forEach(userId => {
                const user = data[userId];
                if (user.GeneratedLottery) {
                    Object.keys(user.GeneratedLottery).forEach(dateStr => {
                        datesSet.add(dateStr);
                        const lotteryData = user.GeneratedLottery[dateStr];
                        
                        lotteriesArray.push({
                            id: lotteriesArray.length + 1,
                            dateStr,
                            organizationName: user.societyName || user.name || user.fullName || "-",
                            phoneNumber: user.whatsappNo || user.mobileNo || "-",
                            taluka: user.taluka || "-",
                            workName: lotteryData.workName || "-",
                            tenderAmount: lotteryData.tenderAmount || lotteryData.estimatedCost || "-"
                        });
                    });
                }
            });

            // Sort dates
            const sortedDates = Array.from(datesSet).sort((a, b) => {
                const [dayA, monthA, yearA] = a.split('-');
                const [dayB, monthB, yearB] = b.split('-');
                return new Date(yearB, monthB - 1, dayB) - new Date(yearA, monthA - 1, dayA);
            });

            setAvailableDates(sortedDates);
            if (sortedDates.length > 0) {
                setSelectedDate(sortedDates[0]);
            }
            setAllLotteries(lotteriesArray);
        }
        setLoading(false);
    });
  }, []);

  const handleSearch = () => {
    // Already filtered by selectedDate inline
  };

  const filteredData = allLotteries.filter(item => item.dateStr === selectedDate);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-slate-800 text-white shadow-md">
        <div className="container mx-auto px-6 py-6">
          <div className="text-center">
            <h1 className="text-3xl font-bold mb-2">मजूर संस्था लॉटरी यादी</h1>
            <div className="w-24 h-0.5 bg-blue-400 mx-auto mb-3"></div>
            <h2 className="text-lg font-normal">ठाणे जिल्हा परिषद / मजूर संस्था लॉटरी यादी</h2>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div className="container mx-auto px-6 py-6">
        <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <div className="flex flex-col">
              <label htmlFor="lottery-date" className="text-gray-700 font-medium mb-1">
                लॉटरीची तारीख निवडा
              </label>
              <select
                id="lottery-date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded text-gray-700 focus:border-blue-500 focus:outline-none"
              >
                {availableDates.length > 0 ? (
                  availableDates.map(date => (
                    <option key={date} value={date}>{date}</option>
                  ))
                ) : (
                  <option value="">तारीख उपलब्ध नाही</option>
                )}
              </select>
            </div>
            {/* Kept button to match original visual structure */}
            <button 
              onClick={handleSearch}
              className="bg-blue-600 text-white px-6 py-2 rounded font-medium hover:bg-blue-700 transition-colors mt-[28px]"
            >
              Search
            </button>
          </div>
        </div>

        {/* Table Section */}
        <div className="mt-6 bg-white rounded-lg shadow border border-gray-200">
          <div className="bg-gray-100 px-4 py-3 border-b border-gray-300">
            <h3 className="text-base font-semibold text-gray-800">मजूर संस्था लॉटरी यादीची माहिती</h3>
          </div>
          
          <div className="overflow-x-auto">
            {loading ? (
                <div className="p-8 text-center text-gray-500">माहिती लोड होत आहे...</div>
            ) : (
                <table className="w-full">
                  <thead className="bg-slate-700 text-white">
                    <tr>
                      <th className="px-4 py-3 text-left font-medium text-sm">क्रमांक</th>
                      <th className="px-4 py-3 text-left font-medium text-sm">संस्थेचे नाव</th>
                      <th className="px-4 py-3 text-left font-medium text-sm">फोन नंबर</th>
                      <th className="px-4 py-3 text-left font-medium text-sm">तालुका</th>
                      <th className="px-4 py-3 text-left font-medium text-sm">कामाचे नाव</th>
                      <th className="px-4 py-3 text-left font-medium text-sm">रक्कम</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {filteredData.length > 0 ? filteredData.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-50 transition-colors">
                        <td className="px-4 py-3 text-sm font-medium text-gray-900">{index + 1}</td>
                        <td className="px-4 py-3 text-sm text-gray-700">{item.organizationName}</td>
                        <td className="px-4 py-3 text-sm text-gray-700">{item.phoneNumber}</td>
                        <td className="px-4 py-3 text-sm text-gray-700">{item.taluka}</td>
                        <td className="px-4 py-3 text-sm text-gray-700">{item.workName}</td>
                        <td className="px-4 py-3 text-sm font-semibold text-green-700">{item.tenderAmount !== "-" ? `₹${item.tenderAmount}` : "-"}</td>
                      </tr>
                    )) : (
                        <tr>
                            <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
                                कोणतीही माहिती उपलब्ध नाही
                            </td>
                        </tr>
                    )}
                  </tbody>
                </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountantSocDrawLotteryList;
